import { AppNewsSectionDatabase, DatabaseEnum, DatabaseManager, NewsFeedTypeResponse, WarningTypeResponse, QuestionTypeResponse, NoticeBoardTypeResponse, IdeaOfTheWeekTypeResponse } from '@robotical/analytics-gatherer';
const firebaseConfig = {
    apiKey: "AIzaSyAebSKkSVzZ4ePBEgGubtSRHjJbA56RQ3o",
    authDomain: "app-news-hub.firebaseapp.com",
    databaseURL: "https://app-news-hub-default-rtdb.firebaseio.com",
    projectId: "app-news-hub",
    storageBucket: "app-news-hub.appspot.com",
    messagingSenderId: "233522721405",
    appId: "1:233522721405:web:1a16e42bcdc18ccacb7714",
    measurementId: "G-HHFWX8HTN8",
    email: "dev@robotical.io",
    password: "martyRocks"
}
let db: AppNewsSectionDatabase;
let dbInstance: DatabaseManager;
// initialise the database
const getOrInitDb = async () => {
    if (db) return db;
    dbInstance = DatabaseManager.getInstance();
    db = await dbInstance.initializeOrGetDatabase(DatabaseEnum.APP_NEWS_SECTION, firebaseConfig, DatabaseEnum.APP_NEWS_SECTION) as AppNewsSectionDatabase;
    return db;
}

export async function getLatestAppVersion(): Promise<string> {
    const db = await getOrInitDb();
    return db.getLatestAppVersion();
}

export async function getLatestMartyVersion(): Promise<string> {
    const db = await getOrInitDb();
    return db.getLatestMartyVersion();
}

export async function getNoticeBoard(): Promise<NoticeBoardTypeResponse> {
    const db = await getOrInitDb();
    return db.getNoticeBoard();
}

export async function getIdeaOfTheWeek(): Promise<IdeaOfTheWeekTypeResponse> {
    const db = await getOrInitDb();
    return db.getIdeaOfTheWeek();
}

export async function getNewsFeed(latestNewsCount?: number): Promise<NewsFeedTypeResponse> {
    const db = await getOrInitDb();
    return db.getNewsFeed(latestNewsCount);
}

export async function getAllWarnings(): Promise<WarningTypeResponse> {
    const db = await getOrInitDb();
    return db.getAllWarnings();
}

export async function fetchQuestionOfTheWeek(): Promise<QuestionTypeResponse> {
    const db = await getOrInitDb();
    return db.getQuestionOfTheWeek();
}

export const answerQuestion = async (questionId: string, questionText: string, answer: string, serialNo: string | null, deviceId: string | null): Promise<void> => {
    const db = await getOrInitDb();
    return db.storeAnswer(questionId, questionText, answer, serialNo, deviceId);
}

getOrInitDb();